import helper from '@/commons/helper';
import axios from 'axios';
import _ from 'lodash';
import qs from 'qs';

export default {
  getLoginSetting(prefixCode) {
    const endpoint = 'reservation/lookup/' + prefixCode + '/settings';
    const url = helper.initUrl(endpoint, false);
    return axios.get(url);
  },

  destroySession() {
    const url = helper.initUrl('reservation/lookup/session/destroy');
    return axios.get(url);
  },

  getUnitDetails() {
    const url = helper.initUrl('reservation/lookup/unit');
    return axios.get(url);
  },

  getReservationDetails() {
    const url = helper.initUrl('reservation/lookup/reservation');
    return axios.get(url);
  },

  getCharges() {
    const url = helper.initUrl('reservation/lookup/charges');
    return axios.get(url);
  },

  getEquipment() {
    const url = helper.initUrl('reservation/lookup/equipment');
    return axios.get(url);
  },

  Payment: (() => {
    let that = {};

    that.createSlimCdTokenizationRequest = function(cardNumber, expMonth, expYear, cvv2, firstName, lastName) {
      return {
        cardnumber: cardNumber,
        expmonth: expMonth,
        expyear: expYear,
        cvv2: cvv2,
        first_name: firstName,
        last_name: lastName
      };
    };

    that.getPayments = function() {
      const url = helper.initUrl('reservation/lookup/payments');
      return axios.get(url);
    };

    that.initPayment = function(data) {
      const url = helper.initUrl('reservation/lookup/payments/initialize');
      return axios.post(url, data);
    };

    that.tokenizeSlimCd = function(tokenizationRequest, username, url) {
      const request = _.clone(tokenizationRequest);
      request.username = username;
      request.amount = '0.00';
      request.transtype = 'LOAD';

      return axios.post(url, qs.stringify(request),
        {timeout: 60000, headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
    };

    that.pollGuid = function(guid) {
      const url = helper.initUrl('reservation/lookup/payments/poll?guid=' + guid);
      return axios.get(url);
    };

    that.completePayment = function(data) {
      const url = helper.initUrl('reservation/lookup/payments/complete');
      return axios.post(url, data);
    };

    return that;
  })(),

  createSession(prefixCode, reservationNumber, lastName) {
    const url = helper.initUrl('reservation/lookup/session/create', false);

    const data = {
      prefixCode: prefixCode,
      reservationNumber: reservationNumber,
      lastName: lastName
    };

    return axios.post(url, data);
  }
};

